import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_table-shelf.scss'

import addSubcomponents from '../utils/addSubcomponents'
import { Props, DivAttributes } from '../utils/types'

const cx = bind(styles)

export const Shelf = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cx('core-table-shelf', className)} {...props}>
      {children}
    </div>
  )
)

export const Head = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cx('core-table-shelf__head')}>
      <div className={cx('core-table-shelf__head-row', className)} {...props}>
        {children}
      </div>
    </div>
  )
)

export const HeadCell = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cx('core-table-shelf__th', className)} {...props}>
      {children}
    </div>
  )
)

export const Body = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cx('core-table-shelf__body')}>
      {children}
    </div>
  )
)

export const BodyCell = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cx('core-table-shelf__td', className)} {...props}>
      {children}
    </div>
  )
)

export const BodyRow = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cx('core-table-shelf__body-row', className)}
      {...props}
    >
      {children}
    </div>
  )
)

Shelf.displayName = 'Shelf'

Body.displayName = 'Shelf.Body'

BodyCell.displayName = 'Shelf.BodyCell'

BodyRow.displayName = 'Shelf.BodyRow'

Head.displayName = 'Shelf.Head'

HeadCell.displayName = 'Shelf.HeadCell'

export default addSubcomponents(
  {
    Body,
    BodyCell,
    BodyRow,
    Head,
    HeadCell,
  },
  Shelf
)
